import React from "react";
import { Link, useLocation } from "react-router-dom";

const SideNav = ({ toggle, setToggle }) => {
  const location = useLocation();
  const handleClick = () => {
    setToggle(false);
  };

  return (
    <div className="sidebar pe-4 pb-3" style={{ marginLeft: toggle ? 0 : "" }}>
      <nav className="navbar bg-secondary navbar-dark">
        <Link to="" className="navbar-brand mx-4 mb-3">
          <img className="logoimg" src="img/paygold-logo.png" alt="" />
        </Link>

        <div className="navbar-nav w-100">
          <div className="nav-item ">
            <Link
              to="/"
              className={
                location.pathname === "/"
                  ? "dropdown-item activeMenu"
                  : "dropdown-item"
              }
              onClick={handleClick}
            >
              {" "}
              <img src="./img/icon-4.png" alt="" /> Dashboard
            </Link>
          </div>
          <div className="nav-item ">
            <Link
              to="/staking-pool"
              className={
                location.pathname === "/staking-pool"
                  ? "dropdown-item activeMenu"
                  : "dropdown-item"
              }
              onClick={handleClick}
            >
              {" "}
              <img src="./img/icon-4.png" alt="" /> Staking Pool
            </Link>
          </div>
          <div className="nav-item ">
            <Link
              to="/transaction"
              className={
                location.pathname === "/transaction"
                  ? "dropdown-item activeMenu"
                  : "dropdown-item"
              }
              onClick={handleClick}
            >
              {" "}
              <img src="./img/icon-4.png" alt="" /> Transaction
            </Link>
          </div>
          <div className="nav-item ">
            <Link
              to="https://paygold-chat-frontend.vercel.app/"
              className={
                location.pathname === "/chat"
                  ? "dropdown-item activeMenu"
                  : "dropdown-item"
              }
              onClick={handleClick}
            >
              {" "}
              <img src="./img/icon-4.png" alt="" /> Send and Receive Money
            </Link>
          </div>
          {/* 
                    <div className="nav-item dropdown">
                        <a href="#" className={location.pathname === '/manage-checkouts' || location.pathname === '/create-new-checkout' ? "nav-link dropdown-toggle show1" : "nav-link dropdown-toggle" } data-bs-toggle="dropdown" aria-expanded={location.pathname === '/manage-checkouts' || location.pathname === '/create-new-checkout' ? "true" : "false"}><img src="./img/icon-7.png" alt="" /> Checkouts</a>
                        <div className={location.pathname === '/manage-checkouts' || location.pathname === '/create-new-checkout' ? "dropdown-menu bg-transparent border-0 show1" : "dropdown-menu bg-transparent border-0"}>
                            <Link to="/manage-checkouts" className={location.pathname  === "/manage-checkouts" ? "dropdown-item activeMenu" : "dropdown-item"} onClick={handleClick}> Manage Checkouts</Link>
                            <Link to="/create-new-checkout" className={location.pathname  === "/create-new-checkout" ? "dropdown-item activeMenu" : "dropdown-item"} onClick={handleClick}> Create New Checkout</Link>
                        </div>
                    </div>
                    <div className="nav-item dropdown">
                        <a href="#" className={location.pathname === '/manage-deposits' || location.pathname === '/create-new-deposit' ? "nav-link dropdown-toggle show1" : "nav-link dropdown-toggle" } data-bs-toggle="dropdown" aria-expanded={location.pathname === '/manage-deposits' || location.pathname === '/create-new-deposit' ? "true" : "false"}><img src="./img/icon-6.png" alt="" /> Deposits</a>
                        <div className={location.pathname === '/manage-deposits' || location.pathname === '/create-new-deposit' ? "dropdown-menu bg-transparent border-0 show1" : "dropdown-menu bg-transparent border-0"}>
                            <Link to="/manage-deposits" className={location.pathname  === "/manage-deposits" ? "dropdown-item activeMenu" : "dropdown-item"} onClick={handleClick}> Manage Deposits</Link>
                            <Link to="/create-new-deposit" className={location.pathname  === "/create-new-deposit" ? "dropdown-item activeMenu" : "dropdown-item"} onClick={handleClick}> Create New Deposit</Link>
                        </div>
                    </div>
                    <div className="nav-item dropdown">
                        <a href="#" className={location.pathname === '/manage-swaps' || location.pathname === '/create-new-swap' ? "nav-link dropdown-toggle show1" : "nav-link dropdown-toggle" } data-bs-toggle="dropdown" aria-expanded={location.pathname === '/manage-swaps' || location.pathname === '/create-new-swap' ? "true" : "false"}><img src="./img/icon-3.png" alt="" /> Swaps</a>
                        <div className={location.pathname === '/manage-swaps' || location.pathname === '/create-new-swap' ? "dropdown-menu bg-transparent border-0 show1" : "dropdown-menu bg-transparent border-0"}>
                            <Link to="/manage-swaps" className={location.pathname  === "/manage-swaps" ? "dropdown-item activeMenu" : "dropdown-item"} onClick={handleClick}> Manage Swaps</Link>
                            <Link to="/create-new-swap" className={location.pathname  === "/create-new-swap" ? "dropdown-item activeMenu" : "dropdown-item"} onClick={handleClick}> Create New Swap</Link>
                        </div>
                    </div>
                    <div className="nav-item dropdown">
                        <a href="#" className={location.pathname === '/manage-customers' || location.pathname === '/create-new-customer' ? "nav-link dropdown-toggle show1" : "nav-link dropdown-toggle" } data-bs-toggle="dropdown" aria-expanded={location.pathname === '/manage-customers' || location.pathname === '/create-new-customer' ? "true" : "false"}><img src="./img/icon-9.png" alt="" /> Customers</a>
                        <div className={location.pathname === '/manage-customers' || location.pathname === '/create-new-customer' ? "dropdown-menu bg-transparent border-0 show1" : "dropdown-menu bg-transparent border-0"}>
                            <Link to="/manage-customers" className={location.pathname  === "/manage-customers" ? "dropdown-item activeMenu" : "dropdown-item"} onClick={handleClick}> Manage Customers</Link>
                            <Link to="/create-new-customer" className={location.pathname  === "/create-new-customer" ? "dropdown-item activeMenu" : "dropdown-item"} onClick={handleClick}> Create New Customers</Link>
                        </div>
                    </div> */}
        </div>
      </nav>
    </div>
  );
};

export default SideNav;
